import { LazyImport, LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import DictationPlugin from './plugin/DictationPlugin';
import { PluginEventType } from 'roosterjs-editor-types';
import { TOGGLE_DICTATION_SOURCE } from './utils/toggleDictation';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "DictationPlugin" */ './lazyIndex')
);

export let LazyDictationPluginClass = createLazyPlugin(
    lazyModule,
    m => m.DictationPlugin,
    'Dictation',
    evt => evt.eventType == PluginEventType.ContentChanged && evt.source == TOGGLE_DICTATION_SOURCE
);

export const lazyGetDictationLanguagePickerDropDown = new LazyImport(
    lazyModule,
    m => m.getDictationLanguagePickerDropDown
);

export const lazyToggleDictation = new LazyImport(lazyModule, m => m.toggleDictation);

export type LazyDictationPlugin = LazyPlugin<DictationPlugin>;
export { default as loadSetDictationLanguageMenu } from './plugin/loadSetDictationLanguageMenu';
export { getDictationStore } from './store/store';
